'use client';

import { useMemo, useState } from 'react';
import Link from 'next/link';
import { ListingsSlider } from '@/features/listings/components/ListingsSlider';
import { Listing } from '@/features/listings/types';
import { cn } from '@/shadcn/lib/utils';

type VisibleOffers = 'sale' | 'rent' | 'demand';

interface Props {
    listings?: Partial<Record<VisibleOffers, Listing[]>>;
    allOffersHref?: string;
}

export function BrokerOffers(props: Props) {
    const [visibleOffers, setVisibleOffers] = useState<VisibleOffers>('sale');

    const BUTTONS = useMemo(() => {
        return [
            { key: 'sale' as const, text: 'Predaj' },
            { key: 'rent' as const, text: 'Prenájom' },
            { key: 'demand' as const, text: 'Dopyt' },
        ];
    }, []);

    const listings = props.listings?.[visibleOffers] ?? [];

    return (
        <div>
            <div className="my-[12px] flex gap-[10px] justify-center lg:justify-start">
                {BUTTONS.map((button) => {
                    const active = visibleOffers === button.key;
                    return (
                        <button
                            key={button.key}
                            type="button"
                            onClick={() => setVisibleOffers(button.key)}
                            className={cn(
                                'py-[8px] px-[25px] rounded-[30px] font-[600] text-[13px] cursor-pointer',
                                'transition duration-200 ease-[cubic-bezier(.22,.61,.36,1)]',
                                'lg:text-[14px] lg:py-[10px]',
                                active
                                    ? 'bg-cust-primary'
                                    : 'bg-[#f3f3f3] hover:bg-[#e9e9e9]',
                            )}
                        >
                            {button.text}
                        </button>
                    );
                })}
            </div>
            <div>
                {listings.length > 0 ? (
                    <ListingsSlider
                        key={visibleOffers}
                        maxSlidesPerView={4}
                        background="grey"
                        listings={listings}
                    />
                ) : (
                    <div className="py-[60px] text-center text-[13px] text-[#858585]">
                        Maklér tu zatiaľ nemá žiadne ponuky.
                    </div>
                )}
            </div>
            {props.allOffersHref && (
                <div className="mt-[15px] flex justify-end">
                    <Link
                        href={props.allOffersHref}
                        className={cn(
                            'text-[13px] font-[600] underline underline-offset-[3px]',
                            'transition-colors duration-200 ease-[cubic-bezier(.22,.61,.36,1)]',
                            'text-cust-primary hover:text-black',
                        )}
                    >
                        Všetky ponuky
                    </Link>
                </div>
            )}
        </div>
    );
}
